import { httpRequest } from "./httpRequest";

const covrServicesUrl = window.__ENV__.REACT_APP_COVR_SERVICES_URL

// this should be getting account, account carriers, and account product settings
// may want to also look at adding like an 'overlay gif' to show loading while the call is being made ?
function retrieveAccount() {
  let currentDomain = window && window.location && window.location.host;

  // set from env files based on environment
  const isDev = (window.__ENV__.REACT_APP_IS_DEV_ENVIRONMENT === 'true');

  // check for query string override
  if (isDev) {
    const domainOverride = getAccountDomainOverrideFromQueryString();

    if (domainOverride) {
      currentDomain = domainOverride;
    }
  }

  return  httpRequest.get(`${covrServicesUrl}/api/Account/GetAccount?Domain=${currentDomain}`)
}

const getAccountDomainOverrideFromQueryString = () => {
  const key = 'domain';
  return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[.+*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
}

export { retrieveAccount };


// WEBPACK FOOTER //
// ./src/account.js